var render = function render(){var _vm=this,_c=_vm._self._c;return _c('jeet11',{attrs:{"isRummyOptionSelected":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }